/* global __webpack_public_path__ */
import { lazy } from 'react';

if (typeof window !== 'undefined' && !window.__TRACKME_EDIT_TRACKING__) {
  window.__TRACKME_EDIT_TRACKING__ = true;
  const edited = () => { window.__TRACKME_PAGE_EDITED__ = true; };
  document.addEventListener('input', edited, true);
  document.addEventListener('change', edited, true);
}

export const isChunkLoadError = error => error?.name === 'ChunkLoadError'
  || error?.code === 'CSS_CHUNK_LOAD_FAILED'
  || /Loading (?:CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '');

function useApplicationOrigin() {
  // Webpack retries failed imports after resetting its failed chunk promise.
  // Change both JS and lazy CSS delivery for subsequent imports in this tab.
  if (typeof __webpack_public_path__ !== 'undefined') {
    __webpack_public_path__ = window.location.origin + '/';
  }
}

export async function refreshStaleBuild({ reload = () => window.location.reload() } = {}) {
  // Never automatically reload private pages or a page the user has edited.
  const publicPage = /^\/(?:$|marshruty\/|publictravelplans\/|chto-posmotret\/|(?:gotovye-marshruty|planirovanie-puteshestviy|kak-sostavit-plan-puteshestviya|ii-planirovshchik-puteshestviy|statistika-puteshestviy|o-trackme|guide|booking|oferta|policy|cookie-policy)(?:\/|$))/.test(window.location.pathname);
  if (!publicPage || window.__TRACKME_PAGE_EDITED__) return false;
  const current = Array.from(document.scripts).find(script => /\/static\/js\/main\.[\w-]+\.js(?:\?|$)/.test(script.src));
  if (!current) return false;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 3000);
  try {
    const response = await fetch('/asset-manifest.json', { cache: 'no-store', credentials: 'omit', signal: controller.signal });
    if (!response.ok) return false;
    const manifest = await response.json();
    const next = manifest.files?.['main.js'];
    if (typeof next !== 'string') return false;
    const nextPath = new URL(next, window.location.origin).pathname;
    if (!/^\/static\/js\/main\.[\w-]+\.js$/.test(nextPath) || nextPath === new URL(current.src).pathname) return false;
    if (window.__TRACKME_PAGE_EDITED__) return false;
    const key = `trackme-chunk-reloaded:${nextPath}`;
    // Storage failure disables automatic navigation, so it cannot create a reload loop.
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, '1');
    reload();
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

export async function loadWithRecovery(load) {
  try {
    return await load();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
  }
  useApplicationOrigin();
  try {
    return await load();
  } catch (error) {
    if (isChunkLoadError(error)) await refreshStaleBuild();
    throw error;
  }
}

export default function lazyWithRecovery(load) {
  return lazy(() => loadWithRecovery(load));
}
